import Box, { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)<BoxProps>(() => ({
    width: 400,
    top: "50%",
    left: "50%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    color: "#fff",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    backgroundColor: "rgb(0,0,0,0.7)",
    boxShadow: "24",
    border: "2px solid white",
    fontSize: 24,
    padding: "50px",
}));

export default StyledBox;
